import * as React from "react";
import "./index.css";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import Layout from "./layouts/Layout";
import AuthLayout from "./auth/Layout";
import Products from "./pages/products/index";
import Reports from "./pages/reports/index";
import ReportDetail from "./pages/reports/Detail";
import Receipt from "./pages/receipt/receipt";

import MultiTabPage from "./pages/Tabs";
import Equipment from "./pages/equipment";
import Home from "./pages/Home";

import reportWebVitals from "./reportWebVitals";
import Login from "./auth/Login";
import Register from "./auth/Register";

import { CartProvider } from "./CartContext";
import Dashboard from "./pages/Dashboard";
import Stock from "./pages/stock";
import Sell from "./pages/sell";

const router = createBrowserRouter([
  {
    Component: App,
    children: [
      {
        path: "/",
        Component: Layout,
        children: [
          {
            path: "/",
            Component: Home,
          },
          {
            path: "/buy",
            Component: MultiTabPage,
          },
          {
            path: "/reports",
            Component: Reports,
          },
          {
            path: "/reports/:transactionId",
            Component: ReportDetail,
          },

          {
            path: "/tabs",
            Component: MultiTabPage,
          },
          {
            path: "/equipment",
            Component: Equipment,
          },
          {
            path: "/stock",
            Component: Stock,
          },
          {
            path: "/sell",
            Component: Sell,
          },
        ],
      },
    ],
  },
  {
    path: "/auth",
    Component: AuthLayout,
    children: [
      {
        path: "login",
        Component: Login,
      },
      {
        path: "register",
        Component: Register,
      },
    ],
  },
  {
    path: "/",
    Component: AuthLayout,
    children: [
      {
        path: "/receipt/:transactionId",
        Component: Receipt,
      },
    ],
  },
  {
    path: "/",
    Component: AuthLayout,
    children: [
      {
        path: "/dashboard",
        Component: Dashboard,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <CartProvider>
    <RouterProvider router={router} />
  </CartProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
